'use client'

import { productionUrl } from '@/app/util/env'
import { cn } from '@/util/cn'
import Navigation from '../navigation'
import Video from '../video'
import Typography from '@/app/components/typography'
import BackgroundAnimationLayout from '../background-animation-layout'

const Header = () => (
    <BackgroundAnimationLayout>
        <Navigation className="mb-[2.9rem]" />

        <div className="relative grid place-content-center px-3 text-giphyLightGrey">
            <img
                src={`${productionUrl}/static/img/about/stickers/logo-spin.gif`}
                className="mx-auto block h-[9.625rem] w-auto"
                alt=""
            />

            <Typography
                variant="text-lg"
                fontWeight="bold"
                className="mx-auto mb-[1.375rem] inline-block bg-linear-to-r from-giphyIndigo to-giphyBlue bg-clip-text text-center text-transparent"
                as="h2"
            >
                Animated Search Engine
            </Typography>

            <Typography
                variant="h1"
                as="h1"
                fontFamily="nexaBlack"
                className="mx-auto mb-[1.125rem] text-center"
                fontWeight="bold"
            >
                GIPHY is the platform that animates your world.
            </Typography>

            <Typography variant="text-xl" className="mx-auto max-w-(--content-max-width) text-center">
                GIPHY is not just GIFs... we are Stickers, Clips, and much more. Every day, we are serving{' '}
                <strong className="font-bold text-giphyWhite underline">10+&nbsp;billion</strong> pieces of GIPHY
                content to a daily user reach of{' '}
                <strong className="font-bold text-giphyWhite underline">1+&nbsp;billion</strong> people, helping them
                express themselves and make their everyday conversations more entertaining.
            </Typography>

            <div className="z-10 mx-auto aspect-[16/9] w-full max-w-(--content-max-width)">
                <Video
                    classNames={{
                        videoWrapper: cn('translate-y-[8.25rem]'),
                        overlayWrapper: cn('max-w-(--page-max-width)'),
                    }}
                />
            </div>
        </div>
    </BackgroundAnimationLayout>
)

export default Header
